<template>
  <Page id="home" anchor="home">
    <HomeLanding />
    <HomeServices />
    <HomeBanner />
    <HomeAbout />
    <HomeContact />
  </Page>
</template>

<script>
import HomeServices from "@/components/pages/home/HomeServices.vue";
import HomeContact from "@/components/pages/home/HomeContact.vue";
import HomeLanding from "@/components/pages/home/HomeLanding.vue";
import HomeBanner from "@/components/pages/home/HomeBanner.vue";
import HomeAbout from "@/components/pages/home/HomeAbout.vue";
import Page from "@/components/core/Page.vue";

export default {
  components: {
    HomeServices,
    HomeContact,
    HomeLanding,
    HomeBanner,
    HomeAbout,
    Page,
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      var reveals = document.querySelectorAll(".reveal");

      for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 200;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("reveal-active");
        } else {
          reveals[i].classList.remove("reveal-active");
        }
      }
    },
  },
};
</script>

<style scoped>
</style>